import { ClaimDocTypeGetUseCase } from '../../../application';

export default class ClaimDocTypeGetService {
    constructor() {}

    async execute(event) {
        const request = await ClaimDocTypeGetUseCase(event);

        return request;
    }
}
